module.exports = __webpack_public_path__ + "static/media/app-store.15ddd4e0.png";